// Application dependencies

import { AddressCrud } from "@/interfaces/address.interfaces";
import { CountriesTable } from "@/interfaces/authorisation/countries.interfaces";
import { StatesTable } from "@/interfaces/authorisation/states.interfaces";
import { TimeZonesTable } from "@/interfaces/authorisation/timeZones.Interfaces";

// Company Enums ---------------------------------------------------------------------------------------------------------------------------

export enum CompanyFields {
  Address = "address",
  Country = "country",
  CountryId = "country_id",
  CreatedAt = "created_at",
  Email = "email",
  Id = "id",
  Key = "key",
  Name = "name",
  NormalAddress = "normal_address",
  NormalAddressId = "normal_address_id",
  PostalAddress = "postal_address",
  PostalAddressId = "postal_address_id",
  State = "state",
  StateId = "state_id",
  Telephone = "telephone",
  TimeZone = "time_zone",
  TimeZoneId = "time_zone_id",
  UpdatedAt = "updated_at",
  Zone = "zone",
}

// Company Interfaces ----------------------------------------------------------------------------------------------------------------------

export interface Company {
  [CompanyFields.Address]: string;
  [CompanyFields.CountryId]: number;
  [CompanyFields.CreatedAt]: string | null;
  [CompanyFields.Email]: string;
  [CompanyFields.Id]: number;
  [CompanyFields.Key]: string;
  [CompanyFields.Name]: string;
  [CompanyFields.NormalAddressId]: number | null;
  [CompanyFields.NormalAddress]: AddressCrud | null;
  [CompanyFields.PostalAddressId]: number | null;
  [CompanyFields.PostalAddress]: AddressCrud | null;
  [CompanyFields.StateId]: number;
  [CompanyFields.Telephone]: string;
  [CompanyFields.TimeZoneId]: number;
  [CompanyFields.UpdatedAt]: string | null;
}

export interface CompanyCrud {
  [CompanyFields.Address]: string;
  [CompanyFields.CountryId]: number;
  [CompanyFields.Email]: string;
  [CompanyFields.Id]: number | null;
  [CompanyFields.Key]: string;
  [CompanyFields.Name]: string;
  [CompanyFields.NormalAddressId]: number | null;
  [CompanyFields.NormalAddress]: AddressCrud | null;
  [CompanyFields.PostalAddressId]: number | null;
  [CompanyFields.PostalAddress]: AddressCrud | null;
  [CompanyFields.StateId]: number;
  [CompanyFields.Telephone]: string;
  [CompanyFields.TimeZoneId]: number;
}

export interface CompanyDetail {
  [CompanyFields.Address]: string;
  [CompanyFields.Country]: CountriesTable | null;
  [CompanyFields.CreatedAt]: string | null;
  [CompanyFields.Email]: string;
  [CompanyFields.Id]: number;
  [CompanyFields.Key]: string;
  [CompanyFields.Name]: string;
  [CompanyFields.NormalAddressId]: number | null;
  [CompanyFields.NormalAddress]: AddressCrud | null;
  [CompanyFields.PostalAddressId]: number | null;
  [CompanyFields.PostalAddress]: AddressCrud | null;
  [CompanyFields.State]: StatesTable | null;
  [CompanyFields.Telephone]: string;
  [CompanyFields.TimeZone]: TimeZonesTable | null;
  [CompanyFields.UpdatedAt]: string | null;
}
